"use client";
import { useGetCartQuery } from "@/api/AppApi/services/cart";
import { LottieFileTypes } from "@/api/AppApi/services/company/interfaces/ICompany";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import { useRouter } from "@/app/components/lib/navigation/useRouter";
import ImagesSlider from "./helpers/ImagesSlider";
import { Modal } from "@/utils/bootstrap";
import LottieFileInPage from "@/app/components/lib/lottie-files/LottieFileInPage";
import SpinnerForBtn from "@/app/components/lib/loaders/SpinnerForBtn";
import { PagesPaths } from "@/utils/functions/pages-paths";
import CustomButton, {
  BtnRadius,
  BtnSizes,
  BtnTypes,
} from "@/app/components/lib/CustomButton";
import { useAtom } from "jotai";
import { useTranslation } from "@/hooks/localization/useTranslations";
import { isSignedInAtom } from "@/hooks/authAtoms";
import { crossSellPopupOpenAtom } from "@/hooks/cartAtoms";
import { goToCartAtom } from "./goToCartAtom";
interface props {}

// Re-exported for backward compatibility; the canonical source is ./goToCartAtom.
export { goToCartAtom };
const GoToCartPopUp: React.FC<props> = () => {
  const [show, setShow] = useAtom(goToCartAtom);
  const t = useTranslation();
  const router = useRouter();
  const getCart = useGetCartQuery();
  const items = getCart.data?.result?.items;
  const itemCount = items?.length ?? 0;
  const getCompany = useGetCompanyQuery();
  const [isSignedIn] = useAtom(isSignedInAtom);
  const [crossSellPopupOpen] = useAtom(crossSellPopupOpenAtom);

  const show_go_to_cart_popup =
    getCompany.data?.result?.theme?.components?.product?.show_go_to_cart_popup;
  if (!show_go_to_cart_popup) return null;
  // Adding a product from inside the cart cross-sell popup must not stack a
  // second modal on top of the one the shopper is still using.
  if (crossSellPopupOpen) return null;
  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      dialogClassName="messagebox-dialog"
      contentClassName="go-to-cart-pop-up"
      centered
    >
      <div className="go-to-cart-container">
        <LottieFileInPage
          lottieFileType={LottieFileTypes.cart}
          title={t.item_added_to_cart}
          text={t.your_cart_now_contains + " " + itemCount + " " + t.items}
          titleClass="title"
          textClass="text"
        />
        {!getCart.isFetchedAfterMount ? (
          <SpinnerForBtn dark />
        ) : (
          items && (
            <ImagesSlider imgs={items?.map((item) => item.thumbnail_url)} />
          )
        )}
        <div className="go-to-cart-btns">
          <div className="btn-width">
            <CustomButton
              type={BtnTypes.secondary}
              size={BtnSizes.medium}
              radius={BtnRadius.small}
              fullWidth
              onClick={() => {
                setShow(false);
                router.push(
                  isSignedIn ? PagesPaths.userCheckout : PagesPaths.checkout,
                );
              }}
            >
              {t.go_to_checkout}
            </CustomButton>
          </div>
          <div className="btn-width">
            <CustomButton
              type={BtnTypes.secondary}
              size={BtnSizes.medium}
              radius={BtnRadius.small}
              fullWidth
              onClick={() => {
                setShow(false);
                router.push(PagesPaths.cart);
              }}
            >
              {t.go_to_cart}
            </CustomButton>
          </div>
          <div className="btn-width">
            <CustomButton
              type={BtnTypes.primary}
              size={BtnSizes.medium}
              radius={BtnRadius.small}
              fullWidth
              onClick={() => setShow(false)}
            >
              {t.continue_shopping}
            </CustomButton>
          </div>
        </div>
      </div>
    </Modal>
  );
};
export default GoToCartPopUp;
